var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_59988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.33997C6.75 3.82747 6.45 4.08997 5.925 4.08997C5.6625 4.08997 5.4375 4.01497 5.2875 3.90247C5.1375 3.78997 5.0625 3.60247 5.0625 3.33997C5.0625 3.07747 5.1375 2.92747 5.2875 2.77747C5.4375 2.66497 5.6625 2.58997 5.925 2.58997C6.4875 2.58997 6.75 2.85247 6.75 3.33997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4589 4.90573C6.57173 5.0509 6.64695 5.23235 6.64695 5.48639V8.75256C6.64695 9.0066 6.57173 9.18805 6.4589 9.33322C6.34607 9.47838 6.15803 9.55096 5.89476 9.55096C5.6315 9.55096 5.44345 9.47838 5.33062 9.33322C5.2178 9.18805 5.14258 9.0066 5.14258 8.75256V5.48639C5.14258 4.94202 5.40584 4.68799 5.89476 4.68799C6.15803 4.68799 6.34607 4.76057 6.4589 4.90573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM6 10.6875C3.4125 10.6875 1.3125 8.5875 1.3125 6C1.3125 3.4125 3.4125 1.3125 6 1.3125C8.5875 1.3125 10.6875 3.4125 10.6875 6C10.6875 8.5875 8.5875 10.6875 6 10.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_59988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.c836f91c3d5ffe12c0b7fe721fbb068f.svg";
export { ForwardRef as ReactComponent };